/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetVendorQuery } from '../../models/get-vendor-query';
import { GetVendorQueryResult } from '../../models/get-vendor-query-result';

export interface ApiVendorsGetVendorPost$Params {
  
    /**
     * The query parameters for fetching Vendor .
     */
    body?: GetVendorQuery
}

export function apiVendorsGetVendorPost(http: HttpClient, rootUrl: string, params?: ApiVendorsGetVendorPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVendorQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiVendorsGetVendorPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetVendorQueryResult>;
    })
  );
}

apiVendorsGetVendorPost.PATH = '/api/Vendors/GetVendor';
